import { z } from "zod";

export const usernameSchema = z
  .string()
  .min(4, "用户名至少需要4个字符")
  .max(20, "用户名最多只能有20个字符")
  .regex(/^[a-zA-Z0-9_]+$/, "用户名只能包含字母、数字和下划线");

export const emailSchema = z.string().email("请输入有效的电子邮件地址");

export const phoneSchema = z
  .string()
  .regex(
    /^(?:([+]\d{1,4})[-.\s]?)?(?:[(](\d{1,3})[)][-.\s]?)?(\d{1,4})[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})$/,
    "请输入有效的电话号码",
  );

export enum IdentifierType {
  Username = "username",
  Email = "email",
  Phone = "phone",
}

export const determineIdentifierType = (identifier: string): IdentifierType => {
  if (usernameSchema.safeParse(identifier).success) {
    return IdentifierType.Username;
  }
  if (emailSchema.safeParse(identifier).success) {
    return IdentifierType.Email;
  }
  if (phoneSchema.safeParse(identifier).success) {
    return IdentifierType.Phone;
  }
  throw new Error("Unknown identifier type");
};

export const passwordSchema = z
  .string()
  .min(8, "密码至少需要8个字符")
  .max(20, "密码最多只能有20个字符")
  .regex(
    /^[a-zA-Z0-9@$!%*?&.]+$/,
    "密码只能包含英文字母、数字和指定的特殊字符 @$!%*.?&",
  )
  .regex(/.*[A-Z].*/, "密码至少需要一个大写字母")
  .regex(/.*[a-z].*/, "密码至少需要一个小写字母")
  .regex(/.*\d.*/, "密码至少需要一个数字");
// .regex(/.*[@$!%*?&.].*/, "密码至少需要一个特殊字符");

export const loginSchema = z.object({
  identifier: z.union([usernameSchema, emailSchema, phoneSchema]),
  password: passwordSchema,
  rememberMe: z.boolean().optional(),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type LoginOutput = z.output<typeof loginSchema>;

export const signupSchema = z.object({
  username: usernameSchema,
  email: emailSchema,
  password: passwordSchema,
  otp: z.string().length(6, "验证码必须是6位字符"),
});

export type SignupInput = z.infer<typeof signupSchema>;
export type SignupOutput = z.output<typeof signupSchema>;

//重置密码验证
//TODO: 等待后端接口完善
export const resetPasswordSchema = z.object({
  email: emailSchema,
  newPassword: passwordSchema,
  code: z.string(),
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type ResetPasswordOutput = z.output<typeof resetPasswordSchema>;
